// import completeSourceOfFunds from "./SourceOfFundsTestValues";
import ISourceOfFunds from "./IsourceOfFunds";

export class SourceOfFundsBase extends ISourceOfFunds {
  constructor(dataStore) {
    super()
    this.dataStore = dataStore
  }

  // Returns a promise
  retrieveSof() {
    return this.dataStore.retrieveSof()
  }

  // Returns a promise
  storeSof(sof) {
    return this.dataStore.storeSof(sof)
  }

  // Returns a promise
  createSofUser(user) {
    return this.dataStore.createSofUser(user)
  }
  
  // Returns a promise
  storeSofUser(sofUserId, user) {
    return this.dataStore.storeSofUser(sofUserId, user)
  }
  
  // Returns a promise
  retrieveSofUser(sofUserId) {
    return this.dataStore.retrieveSofUser(sofUserId)
  }
  
  // Returns a promise
  listSofUsers(sofId) {
    return this.dataStore.listSofUsers(sofId)
  }

  // Returns a promise
  addSofUserToAdmin(sofUserId) {
    return this.dataStore.addSofUserToAdmin(sofUserId)
  }

  // Returns a promise
  removeSofUserFromAdmin(sofUserId) {
    return this.dataStore.removeSofUserFromAdmin(sofUserId)
  }

  // Returns a promise
  resendPasswordToSofUser(sofUserId) {
    return this.dataStore.resendPasswordToSofUser(sofUserId)
  }

  // Returns a promise
  resetPasswordToSofUser(sofUserId) {
    return this.dataStore.resetPasswordToSofUser(sofUserId)
  }
  
}

export default SourceOfFundsBase